import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { FetchEligibility } from "../../../../../api/helper";
import moment from "moment";

const EligibilityChecks = ({ info, activeTab }) => {
  const [showModal, setShowModal] = useState(false);
  const [eligibilitydata, setEligibilitydata] = useState({
    data: [],
    pagination: { totalPages: 0 },
  });
  const pageSize = 10;
  const [currentlabspage, setcurrentlabspage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleOpenModal = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };
  const profiledata = useSelector((state) => state?.cookies?.userDetails);

  const getEligibilitydata = async (page = 1) => {
    try {
      const respo = await FetchEligibility(
        profiledata?._id,
        info?.patientId?._id,
        pageSize,
        page
      );
      setEligibilitydata({
        data: respo.data.data?.data,
        pagination: respo.data.data.pagination || { totalPages: 0 },
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (activeTab === "EligibilityChecks") {
      getEligibilitydata();
    }
  }, [activeTab]);
  const handlelabsPageChange = (page) => {
    setcurrentlabspage(page);
    getEligibilitydata(page);
  };

  const handlePrintDetails = () => {
    const originalContent = document
      .getElementById("printableArea")
      .cloneNode(true);

    originalContent.querySelectorAll(".accordion-body").forEach((body) => {
      body.style.display = "block";
    });

    const printWindow = window.open(" ", " ", "height=600,width=800");

    printWindow.document.write(`
    <html>
      <head>
        <title>Member Eligibility Details</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 1rem; }
          th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
          h5, h6 { margin-top: 0; }
          .accordion-body { display: flex; flex-direction: column; align-items: flex-start; padding: 10px; color: #333; }
          .accordion-header { color: #000; font-size: 24px; font-weight: 800; margin-left: 10px; }
          .custom-card {
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            border: 1px solid #ddd;
            margin-top: 10px;
          }
          .custom-card-header {
            background: #007bff;
            color: #fff;
            padding: 12px 15px;
            font-size: 16px;
            font-weight: bold;
          }
          .card-header_two {
            background-color: #011434 !important;
            color: #bc9c22 !important;
            text-align: left;
            padding: 10px;
          }
          .custom-card-title {
            margin: 0;
            font-size: 20px;
          }
          .custom-card-body {
            padding: 15px;
          }
          .card-body-custom {
            padding: 1rem;
          }
          .Eligibilitytable th {
            background-color: #d9d9d9;
            color: black;
          }
          .custom-modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1050;
          }
          .custom-modal-dialog {
            height: 95%;
            width: 90%;
            max-width: 900px;
            background: #fff;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
          }
          .custom-modal-content {
            display: flex;
            flex-direction: column;
          }
          .custom-modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px;
            background: #f8f9fa;
            border-bottom: 1px solid #ddd;
          }
          .modal-title {
            font-size: 18px;
            font-weight: bold;
            margin: 0;
          }
          footer {
            margin-top: 40px;
            text-align: center;
            font-weight: bold;
            font-size: 16px;
            color: #333;
            border-top: 1px solid #ccc;
            padding-top: 10px;
          }
        </style>
      </head>
      <body>
        <div style="text-align: center; font-size: 22px; font-weight: bold; margin-bottom: 20px;">
          Eligibility Report for ${info?.firstName} ${info?.lastName}
        </div>
        ${originalContent.innerHTML}
        <title>Member Eligibility Details</title>
        <script>
          window.onload = function () {
            window.print();
            window.close();
          };
        </script>
      </body>
    </html>
  `);

    printWindow.document.close();
  };

  // console.log(eligibilitydata?.data,"eligibilitydata======")
  return (
    <>
      <div className="container-custom">
        <div className="card-custom">
          <div className="card-header_two-custom">
            <h4>Eligibility Checks History</h4>
          </div>
          <div className="card-body-custom">
            <div className="table-responsive-custom">
              <table className="table-custom">
                <thead>
                  <tr>
                    <th>Date Run</th>
                    <th>Eligibility Status</th>
                    <th>In-Network Status</th>
                    <th style={{ width: 150 }}>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {eligibilitydata?.data.length > 0 ? (
                    eligibilitydata?.data.map((item, index) => {
                      const dateRun = moment(item.createdAt).format(
                        "MM/DD/YYYY"
                      );
                      const hasErrors = item.data?.errors?.length > 0;
                      const eligibilityStatus = hasErrors
                        ? "Not Eligible"
                        : "Eligible";
                      const networkStatus = hasErrors
                        ? "Out of Network"
                        : "In-Network";

                      return (
                        <tr key={index}>
                          <td>{dateRun}</td>
                          <td>{eligibilityStatus}</td>
                          <td>{networkStatus}</td>
                          <td className="action-links">
                            <a
                              className="no-print"
                              onClick={() => handleOpenModal(item)}
                            >
                              Download
                            </a>
                            &nbsp;|&nbsp;
                            <a
                              className="no-print"
                              onClick={() => handleOpenModal(item)}
                            >
                              Print
                            </a>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center" }}>
                        No Data Available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* Previous Button */}
                <button
                  onClick={() => handlelabsPageChange(currentlabspage - 1)}
                  disabled={currentlabspage === 1}
                  style={{
                    margin: "5px",
                    padding: "10px 20px",
                    backgroundColor: currentlabspage === 1 ? "#ccc" : "#007BFF",
                    color: "#fff",
                    border: "1px solid #007BFF",
                    cursor: currentlabspage === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  Previous
                </button>

                <span
                  style={{
                    margin: "5px",
                    padding: "10px 20px",
                    backgroundColor: "#fff",
                    color: "#000",
                    border: "1px solid #007BFF",
                  }}
                >
                  {currentlabspage} of {eligibilitydata?.pagination?.totalPages}
                </span>

                <button
                  onClick={() => handlelabsPageChange(currentPage + 1)}
                  disabled={
                    currentlabspage === eligibilitydata?.pagination?.totalPages
                  }
                  style={{
                    margin: "5px",
                    padding: "10px 20px",
                    backgroundColor:
                      currentlabspage ===
                      eligibilitydata?.pagination?.totalPages
                        ? "#ccc"
                        : "#007BFF",
                    color: "#fff",
                    border: "1px solid #007BFF",
                    cursor:
                      currentlabspage ===
                      eligibilitydata?.pagination?.totalPages
                        ? "not-allowed"
                        : "pointer",
                  }}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && selectedItem && (
        <div className="custom-modal">
          <div className="custom-modal-dialog">
            <div className="custom-modal-content">
              <div className="custom-modal-header">
                <h5 className="modal-title" id="eligibilityModalLabel">
                  Member Eligibility Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleCloseModal}
                />
              </div>
              <div className="custom-modal-body" id="printableArea">
                <div className="custom-card">
                  <div className="card-header_two">
                    <div className="custom-card-title">Member Information</div>
                  </div>
                  <div className="custom-card-body">
                    <table className="Eligibilitytable">
                      <tbody>
                        <tr>
                          <th scope="row">Name</th>
                          <td>{`${selectedItem.data.subscriber.firstName} ${selectedItem.data.subscriber.lastName}`}</td>
                          <th scope="row">Member ID</th>
                          <td>{selectedItem.data.subscriber.memberId}</td>
                        </tr>
                        <tr>
                          <th scope="row">Date of Birth</th>
                          <td>
                            {moment(
                              selectedItem.data.subscriber.dateOfBirth,
                              "YYYYMMDD"
                            ).format("MM/DD/YYYY")}
                          </td>
                          <th scope="row">Gender</th>
                          <td>{selectedItem.data.subscriber.gender}</td>
                        </tr>
                        <tr>
                          <th scope="row">Address</th>
                          <td colSpan={3}>
                            {`${selectedItem.data.subscriber.address.address1}, ${selectedItem.data.subscriber.address.city}, ${selectedItem.data.subscriber.address.state} ${selectedItem.data.subscriber.address.postalCode}`}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Relationship to Subscriber</th>
                          <td colSpan={3} id="relationshipCell">
                            {selectedItem.data.subscriber.relationToSubscriber}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="custom-card">
                  <div className="card-header_two">
                    <div className="mb-0">Plan &amp; Eligibility Info</div>
                  </div>
                  <div className="card-body">
                    <table className="Eligibilitytable table-bordered mb-0">
                      <tbody>
                        <tr>
                          <th scope="row">Plan Name</th>
                          <td>
                            {selectedItem.data.planStatus?.[0]?.status ?? "N/A"}
                          </td>
                          <th scope="row">Group Number</th>
                          <td>{selectedItem.data.tradingPartnerServiceId}</td>
                        </tr>
                        <tr>
                          <th scope="row">Plan Coverage</th>
                          <td>
                            {selectedItem.data.planDateInformation.eligibility}
                          </td>
                          <th scope="row">Eligibility Status</th>
                          <td>
                            {selectedItem.data.planStatus?.[0]?.status ?? "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Eligibility Begin</th>
                          <td>
                            {
                              selectedItem.data.planDateInformation.eligibility.split(
                                "-"
                              )[0]
                            }
                          </td>
                          <th scope="row">Eligibility End</th>
                          <td>
                            {
                              selectedItem.data.planDateInformation.eligibility.split(
                                "-"
                              )[1]
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="custom-card">
                  <div className="card-header_two">
                    <div className="mb-0">Information Receiver</div>
                  </div>
                  <div>
                    <table className="Eligibilitytable table-bordered mb-0">
                      <tbody>
                        <tr>
                          <th scope="row">Type</th>
                          <td>Provider, Non-Person</td>
                          <th scope="row">Name</th>
                          <td>General Health Clinic</td>
                        </tr>
                        <tr>
                          <th scope="row">NPI</th>
                          <td colSpan={3}>1234567890</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="custom-card">
                  <div className="card-header_two">
                    <div className="mb-0">Member Benefit Details</div>
                  </div>
                  <div className="card-body">
                    <div className="accordion" id="benefitsAccordion">
                      <div className="accordion-item">
                        <div
                          className="accordion-header"
                          data-bs-toggle="collapse"
                          data-bs-target="#generalCollapse"
                          aria-expanded="false"
                          aria-controls="generalCollapse"
                        >
                          General
                        </div>
                        <div
                          id="inpatientCollapse"
                          aria-labelledby="inpatientHeading"
                          data-bs-parent="#benefitsAccordion"
                        >
                          <div className="accordion-body">
                            <p style={{ textAlign: "left", color: "black" }}>
                              <strong>Coverage Type:</strong> Health Benefit
                              Plan Coverage
                            </p>
                            <p style={{ textAlign: "left", color: "black" }}>
                              <strong>Insurance Type:</strong> PPO
                            </p>
                            <p style={{ textAlign: "left", color: "black" }}>
                              <strong>Description:</strong> Standard plan
                              coverage details for general benefits.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <div
                          className="accordion-header"
                          data-bs-toggle="collapse"
                        >
                          Plan Waiting Period
                        </div>

                        <div
                          id="waitingCollapse"
                          aria-labelledby="inpatientHeading"
                          data-bs-parent="#benefitsAccordion"
                        >
                          <div className="accordion-body">
                            <div style={{ color: "black" }}>
                              No waiting period applies for pre-existing
                              conditions. Coverage is effective immediately on
                              eligibility date.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <div
                          className="accordion-header"
                          data-bs-toggle="collapse"
                          data-bs-target="#inpatientCollapse"
                          aria-expanded="false"
                          style={{ color: "black" }}
                        >
                          Hospital - Inpatient
                        </div>

                        <div
                          id="inpatientCollapse"
                          aria-labelledby="inpatientHeading"
                          data-bs-parent="#benefitsAccordion"
                        >
                          <div className="accordion-body">
                            <p style={{ color: "black" }}>
                              <strong>Eligibility or Benefit:</strong>{" "}
                              Co-Insurance (20%)
                            </p>
                            <p style={{ color: "black" }}>
                              <strong>
                                Required Authorization or Certification:
                              </strong>{" "}
                              Yes
                            </p>
                            <p style={{ color: "black" }}>
                              <strong>In-Network:</strong> Yes
                            </p>
                            <p style={{ color: "black" }}>
                              <strong>Message:</strong> Required for
                              non-emergent musculoskeletal procedures.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <div
                          className="accordion-header"
                          data-bs-toggle="collapse"
                          data-bs-target="#outpatientCollapse"
                          aria-expanded="false"
                          aria-controls="outpatientCollapse"
                          style={{ color: "black" }}
                        >
                          Hospital - Outpatient
                        </div>

                        <div
                          id="outpatientCollapse"
                          aria-labelledby="outpatientHeading"
                          data-bs-parent="#benefitsAccordion"
                        >
                          <div className="accordion-body">
                            <p style={{ color: "black" }}>
                              <strong>Eligibility or Benefit:</strong>{" "}
                              Co-Insurance (20%)
                            </p>
                            <p style={{ color: "black" }}>
                              <strong>
                                Required Authorization or Certification:
                              </strong>{" "}
                              Yes
                            </p>
                            <p style={{ color: "black" }}>
                              <strong>In-Network:</strong> Yes
                            </p>
                            <p style={{ color: "black" }}>
                              <strong>Message:</strong> Surgical and
                              non-surgical outpatient visits require
                              pre-certification.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <div
                          className="accordion-header"
                          data-bs-toggle="collapse"
                          data-bs-target="#pharmacyCollapse"
                          aria-expanded="false"
                          aria-controls="pharmacyCollapse"
                          style={{ color: "black" }}
                        >
                          Pharmacy
                        </div>
                        <div
                          id="pharmacyCollapse"
                          aria-labelledby="pharmacyHeading"
                          data-bs-parent="#benefitsAccordion"
                        >
                          <div className="accordion-body">
                            <p style={{ color: "black" }}>
                              <strong>Eligibility or Benefit:</strong>{" "}
                              Co-Payment
                            </p>
                            <p style={{ color: "black" }}>
                              <strong>Amount:</strong> $10 (Generic), $25
                              (Brand)
                            </p>
                            <p style={{ color: "black" }}>
                              <strong>In-Network:</strong> Yes
                            </p>
                            <p style={{ color: "black" }}>
                              <strong>Message:</strong> Retail and mail-order
                              prescription drugs. Specialty prescriptions may
                              differ.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <div
                          className="accordion-header"
                          data-bs-toggle="collapse"
                          data-bs-target="#otherCollapse"
                          aria-expanded="false"
                          aria-controls="otherCollapse"
                          style={{ color: "black" }}
                        >
                          Other Medical
                        </div>

                        <div
                          id="otherCollapse"
                          aria-labelledby="otherHeading"
                          data-bs-parent="#benefitsAccordion"
                        >
                          <div className="accordion-body">
                            <p style={{ color: "black" }}>
                              <strong>Eligibility or Benefit:</strong> Out of
                              Pocket (Stop Loss)
                            </p>
                            <p style={{ color: "black" }}>
                              <strong>Coverage:</strong> Individual / Family
                            </p>
                            <p style={{ color: "black" }}>
                              <strong>Amount:</strong> $2,000 (Individual) /
                              $4,000 (Family)
                            </p>
                            <p style={{ color: "black" }}>
                              <strong>In-Network:</strong> Yes
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer_two">
                <button
                  type="button"
                  className="btn_close_print btn_close_print-secondary no-print"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn_close_print btn_close_print-secondary no-print"
                  style={{ marginLeft: 10 }}
                  onClick={handlePrintDetails}
                >
                  Print Detail
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EligibilityChecks;
